import { render } from "./ProductDatabaseView.vue?vue&type=template&id=4f89e504&scoped=true"
import script from "./ProductDatabaseView.vue?vue&type=script&lang=js"
export * from "./ProductDatabaseView.vue?vue&type=script&lang=js"

import "./ProductDatabaseView.vue?vue&type=style&index=0&id=4f89e504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f89e504"]])

export default __exports__